import MetaService from '@/services/resources/MetaService';

const serviceMeta = MetaService.build();

const state = () => ({
  metas: {},
  pendingRequests: {},
});

const mutations = {
  SET_METAS(state, newMetas) {
    state.metas = { ...state.metas, ...newMetas };
  },
  SET_META(state, { key, value }) {
    state.metas = { ...state.metas, [key]: value };
  },
  RESET_STATE(state) {
    state.metas = {};
    state.pendingRequests = {};
  },
  REMOVE_META(state, key) {
    const newMetas = { ...state.metas };
    delete newMetas[key];
    state.metas = newMetas;
  },
  SET_PENDING_REQUEST(state, { key, promise }) {
    state.pendingRequests = { ...state.pendingRequests, [key]: promise };
  },
  REMOVE_PENDING_REQUEST(state, key) {
    const newPendingRequests = { ...state.pendingRequests };
    delete newPendingRequests[key];
    state.pendingRequests = newPendingRequests;
  },
};

const actions = {
  async fetchMetas({ state, commit }, keysToSearch) {
    const keysAlreadyAvailable = new Set(Object.keys(state.metas));
    const keysWithPendingRequest = new Set(Object.keys(state.pendingRequests));

    const keysToFetch = keysToSearch.filter(
      key => !keysAlreadyAvailable.has(key) && !keysWithPendingRequest.has(key)
    );

    if (keysToFetch.length > 0) {
      const queryString = keysToFetch.map(key => `keys[]=${encodeURIComponent(key)}`).join('&');
      const requestPromise = serviceMeta.search(queryString)
        .then(response => {
          commit('SET_METAS', response);
          return response;
        })
        .finally(() => {
          keysToFetch.forEach(key => commit('REMOVE_PENDING_REQUEST', key));
        });

      keysToFetch.forEach(key => {
        commit('SET_PENDING_REQUEST', { key, promise: requestPromise });
      });
    }

    const promisesToWait = keysToSearch
      .map(key => state.pendingRequests[key])
      .filter(Boolean);

    if (promisesToWait.length > 0) {
      await Promise.all(promisesToWait);
    }

    const result = {};
    keysToSearch.forEach(key => {
      if (state.metas[key] !== undefined) {
        result[key] = state.metas[key];
      }
    });
    return result;
  },
  updateMetas({ commit }, { id, value }) {
    commit('SET_META', { key: id, value });
  },
};

const getters = {
  allMetas: (state) => state.metas,
  getMetaByKey: (state) => (key) => state.metas[key],
};

export { state, mutations, actions, getters };